import { defineStore } from 'pinia';
import { useApiStore } from './apiStore';
import { useAuthStore } from './authStore';
export const useQuizStore = defineStore('quiz', {
    state: () => ({
        quiz: {
            questions: [],
        },
        userEmail: '',
        isMenuOpen: true,
        mode: 'quiz',
        step: 0,
        selectedItem: {
            id: null,
            type: null,
            answerId: null,
        },
        selectedAnswer: {},
    }),
    actions: {
        nextStep(totalQuestions) {
            if (this.step < totalQuestions - 1) {
                this.step++;
            } else {
                this.resetStep();
            }
        },
        resetStep() {
            this.step = 0;
        },
        setUserEmail(email) {
            this.userEmail = email;
        },
        getUserEmail() {
            return this.userEmail;
        },
        setSelectedAnswer(answers) {
            this.selectedAnswer = answers;
        },
        setQuiz(quiz) {
            this.quiz = quiz;
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        setMode(mode) {
            this.mode = mode;
        },
        setSelectedItem(id, type, answerId = null) {
            this.selectedItem = { id, type, answerId };
        },
        resetSelectedItem() {
            this.selectedItem = { id: null, type: null, answerId: null };
        },
        addDetails(type) {
            const supportedLocales = ['en', 'fr', 'nl'];

            switch (type) {
                case 'question': {
                    !this.quiz.questions ? (this.quiz.questions = []) : null;
                    const id = this.quiz.questions.length + 1;
                    const newQuestion = {
                        id,
                        description: {},
                        points: {
                            positive: 1,
                            negative: 0,
                        },
                        explanation: {},
                        answers: [],
                    };

                    supportedLocales.forEach(locale => {
                        newQuestion.description[locale] = '';
                        newQuestion.explanation[locale] = '';
                    });

                    this.quiz.questions.push(newQuestion);

                    this.setSelectedItem(id, 'question');
                    this.setMode('question');
                    break;
                }
                case 'answer': {
                    const question = this.quiz.questions.find(
                        question => question.id === this.selectedItem.id,
                    );
                    if (question) {
                        const answerId = question.answers.length + 1;
                        const newAnswer = {
                            id: answerId,
                            description: {},
                            is_correct: false,
                        };

                        supportedLocales.forEach(locale => {
                            newAnswer.description[locale] = '';
                        });

                        question.answers.push(newAnswer);
                        this.setSelectedItem(question.id, 'answer', answerId);
                        this.setMode('answer');
                    }
                    break;
                }
                default:
                    break;
            }
        },
        async fetchQuiz() {
            const apiStore = useApiStore();
            const authStore = useAuthStore();

            const response = await apiStore.apiGet(
                `/api/quiz/${authStore.$state.user?.companies_id}`,
            );
            this.setQuiz(response.quiz);
        },
        async deleteCard(id) {
            const apiStore = useApiStore();
            const authStore = useAuthStore();

            if (
                (this.selectedItem.type === 'question' &&
                    this.selectedItem.id === id) ||
                (this.selectedItem.type === 'answer' &&
                    this.selectedItem.id === id)
            ) {
                this.resetSelectedItem();
                this.setMode('quiz');
            }
            this.quiz.questions = this.quiz.questions.filter(
                question => question.id !== id,
            );

            await apiStore.apiPost(
                '/api/quiz/' + authStore.$state.user?.companies_id + '/update',
                {
                    title: JSON.stringify(this.quiz.title),
                    description: JSON.stringify(this.quiz.description),
                    questions: JSON.stringify(this.quiz.questions),
                    min_score: this.quiz.min_score,
                },
            );
            this.fetchQuiz();
        },
    },
});

export default useQuizStore;
